/** Offline / connection status banner. Offline-first: cached content stays usable, sends are queued. */
import { msg, type MessageDescriptor } from "../i18n.ts";

export type RealtimeStatus = "connecting" | "online" | "offline";

export type ConnectivityInput = {
  /** Browser/OS network reachability (navigator.onLine / NWPathMonitor / ConnectivityManager). */
  network: boolean;
  realtime: RealtimeStatus;
  /** Messages waiting in the outbox. */
  queued: number;
  /** A cached workspace is being shown. */
  hasCache: boolean;
};

export type Banner = { tone: "neutral" | "warning"; label: MessageDescriptor };

export function connectivityBanner(input: ConnectivityInput): Banner | undefined {
  if (!input.network) {
    if (input.queued > 0) return { tone: "warning", label: msg("offline.bannerQueued", { count: input.queued }) };
    return { tone: "warning", label: msg(input.hasCache ? "offline.banner" : "offline.bannerNoCache") };
  }
  if (input.realtime === "offline") return { tone: "neutral", label: msg("connection.reconnecting") };
  if (input.queued > 0 && input.realtime === "online") return { tone: "neutral", label: msg("offline.sending", { count: input.queued }) };
  return undefined;
}
